<template>
  <div class="voteReward" :class="{lan_En : lan != 'zh'}">
    <div class="bg1"><img src="../../assets/home/cont4_bg1.jpg" alt=""></div>
    <div class="content1">
      <div class="cont_title gradient_text">{{ $t('voteReward.title') }}</div>
      <div class="cont_desc">{{ $t('voteReward.text') }}</div>
      <a target="_blank" href="https://www.dbcwallet.io/#/staking" class="cont_btn">{{ $t('getReward.seedetails') }}</a>
    </div>
    <div class="content2">
      <p class="cont2_text1">{{ $t('voteReward.cont.title') }}</p>
      <div class="procedure_wiki">
        <p class="procedure_text1">{{ $t('voteReward.procedure1.title1') }}</p>
        <p class="procedure_text2">{{ $t('voteReward.procedure1.text1') }} <a class="procedure_text3" target="_blank" href="https://deepbrainchain.github.io/DBC-Wiki/staking-model/generate-new-account.html">{{ $t('voteReward.procedure1.text2') }}</a></p>
      </div>
      <div class="procedure_wiki">
        <p class="procedure_text1">{{ $t('voteReward.procedure2.title1') }}</p>
        <p class="procedure_text2">{{ $t('voteReward.procedure1.text1') }} <a class="procedure_text3" target="_blank" href="https://www.dbcwallet.io/?rpc=wss://info.dbcwallet.io#/accounts">https://www.dbcwallet.io/?rpc=wss://info.dbcwallet.io#/accounts</a> {{ $t('voteReward.procedure1.text2') }} </p>
        <img class="procedure_img" v-show="lan == 'zh'" src="../../assets/wiki/POS2-1.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/POS2-1-en.png" alt="">
      </div>
      <div class="procedure_wiki">
        <p class="procedure_text1">{{ $t('voteReward.procedure3.title1') }}</p>
        <p class="procedure_text4">{{ $t('voteReward.procedure3.text1') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'" src="../../assets/wiki/POS-2.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/POS-2-en.png" alt="">
        <p class="procedure_text4">{{ $t('voteReward.procedure3.text2') }}</p>
        <img class="procedure_img" v-show="lan == 'zh'" src="../../assets/wiki/POS-3.png" alt="">
        <img class="procedure_img" v-show="lan != 'zh'" src="../../assets/wiki/POS-3-en.png" alt="">
      </div>
    </div>
  </div>
</template>


<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted  } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'voteReward',
    setup() {
      const store = useStore()
      let lan = computed(() =>  store.state.lan)
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      onMounted(() => {

      });
      return {
        lan,
      };
    }
  })
</script>

<style lang="scss" scoped>
.voteReward {
  min-width: 1200px;
  margin: auto;
  font-style: normal;
  // font-family: "Noto Sans SC";
  width: 100%;
  overflow: hidden;
  position: relative;
  .bg1 {
    position: absolute;
    top: -500px;
    margin: auto;
    width: 1920px;
    height: 1690px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 1920px;
      height: 1690px;
    }
  }
  .cont_title {
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    line-height: normal;
    margin-bottom: 40px;
    letter-spacing: 1.6px;
  }
  .cont_desc {
    max-width: 1000px;
    font-size: 16px;
    color: #899AA9;
    font-weight: 400;
    line-height: 24px; 
    text-align: center;
    letter-spacing: 1px;
    a {
      color: #899AA9;
      text-decoration: none;
    }
  }
  .content1 {
    position: relative;
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 100px 0 80px;
    box-sizing: border-box;
    .cont_btn {
      margin: auto;
      color: #FFF;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      margin-top: 40px;
      padding: 10px 60px;
      line-height: normal;
      transition: all .5s;
      text-decoration: none;
      border: 1px solid #FFF;
      &:hover {
        color: #10132F;
        background: #FFF;
      }
    }
  }
  .content2 {
    position: relative;
    width: 1200px;
    margin: auto;
    padding: 100px 0 160px;
    box-sizing: border-box;
    .cont2_text1 {
      color: #FFF;
      font-size: 48px;
      font-weight: 400;
      text-align: center;
      line-height: normal;
      letter-spacing: 1px;
    }
    .cont2_text2 {
      font-size: 16px;
      color: #899AA9;
      font-weight: 400;
      margin-top: 40px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 1px;
    }
    
  }
}

</style>
